<script setup lang="ts">
type SearchType = `area` | `name`;
const searchType = ref<SearchType>(`area`);
</script>

<template>
  <IadWrapper
    class="bg-secondary rounded-t-3xl text-white"
    inner-classes="pt-2xl"
  >
    <IadTitle
      tag="p"
      variant="large"
      class="pb-l"
      :text="$t(`agent.search_form.title`)"
    />
    <IadTitle
      variant="x-small"
      tag="p"
      class="pb-l"
      :text="$t(`agent.search_form.description`)"
    />
    <div class="lg:w-10/12 mx-auto">
      <IadRadioGroup
        v-model="searchType"
        hide-details
      >
        <IadRadioTab
          :label="$t('agent.search_form.by_area')"
          value="area"
        />
        <IadRadioTab
          :label="$t('agent.search_form.by_name')"
          value="name"
        />
      </IadRadioGroup>
      <div class="pb-l">
        <FindAgentSector
          v-if=" searchType === `area`"
          :placeholder="$t('agent.search_form.by_area_placeholder')"
        />
        <FindAgentName v-else />
      </div>
    </div>
  </IadWrapper>
</template>
